import * as React from "react";
import EditorMultipleChoice from '../../../../../../component/common/EditorMultipleChoice'
import Svg from '../../../../../../component/common/Svg'
import Button from '../../../../../../core/Button'
import Tooltip from '../../../../../../core/Tooltip'


export default function Questions() {
    const [value, setValue] = React.useState("<p>Welcome to CKEditor!</p>");

    return (
        <div className="tab-inner-section accordion" id="accordionQuestions">
            <div className="trans-header">
                <div className="row gx-0 lead-gen-wrapper">
                    <div className="col-lg-6">
                        <div className="tab-inner-wrapper">
                            <div className="tab-inner-heading">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="left-wrap d-flex">
                                        <div className="drop-wrap ques-options">
                                            <h5>ENG</h5>
                                            <p>Default</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="tab-inner-wrapper right-tab">
                            <div className="tab-inner-heading">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="left-wrap">
                                        <div className="dropdown table-dropdown ques-options">
                                            <button className="btn dropdown-tgl" type="button" id="languages" data-bs-toggle="dropdown"
                                                aria-haspopup="true" aria-expanded="false">
                                                <span className='me-2'>SPA</span>
                                            </button>
                                            <div className="dropdown-menu" aria-labelledby="languages">
                                                <a className="dropdown-item" href="#">
                                                    English
                                                </a>
                                                <a className="dropdown-item" href="#">
                                                    German
                                                </a>
                                                <a className="dropdown-item" href="#">
                                                    Spanish
                                                </a>
                                            </div>
                                        </div>
                                        <p>English</p>
                                    </div>
                                    <div className="right-action-btn">
                                        <button type="button" className="btn btn-bordered">Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="trans-wrap">
                <div className="row gx-0 lead-gen-wrapper">
                    <div className="col-lg-6">
                        <div className="tab-inner-wrapper left-tab">

                            <div className="questions-wrapper checked">{/*Add Class Checked once checkbox checked*/}
                                <div className="question-list-in">
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="heading1">
                                            <div className="Sortingcheck">
                                                <input type="checkbox" className="form-check-input" id="check1" defaultChecked />
                                            </div>
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#question1" aria-expanded="true" aria-controls="question1">
                                                <strong>Q1</strong> What are the top reasons that made you choose us?
                                            </button>
                                        </h2>
                                        <div id="question1" className="accordion-collapse collapse" aria-labelledby="heading1" data-bs-parent="#accordionQuestions">
                                            <div className="accordion-body">
                                                <ol>
                                                    <li>Very satisfied</li>
                                                    <li>Satisfied</li>
                                                    <li>Dissatisfied  </li>
                                                    <li>Very dissatisfied </li>
                                                </ol>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="tab-inner-wrapper right-tab">
                            <div className="questions-wrapper">
                                <div className="question-list-in">
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="heading1">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#question1" aria-expanded="true" aria-controls="question1">
                                                <strong>Q1</strong> What are the top reasons that made you choose us?
                                            </button>
                                        </h2>
                                        <div id="question1" className="accordion-collapse collapse" aria-labelledby="heading1" data-bs-parent="#accordionQuestions">
                                            <div className="accordion-body">
                                                <div className="question-title">
                                                    <EditorMultipleChoice />
                                                </div>
                                                <div className="language-question-option">
                                                    <div className="secondary-font">Choices </div>
                                                    <div className="choices-list">
                                                        <div className="choices d-flex align-items-center">
                                                            <div className='chiceFields choiceInput'>
                                                                <textarea className="choiceItext" cols={1} defaultValue={"Very satisfied"} />
                                                            </div>
                                                            <div className='chiceFields scoreInput'>
                                                                <Tooltip
                                                                    color='primary'
                                                                    content="Custom variables"
                                                                    position='top'
                                                                    className='black-tooltip'
                                                                >
                                                                    <Button view="outlined" className="action-btn copy ms-3" color="primary" text=""><Svg name="copyright" /></Button>
                                                                </Tooltip>
                                                            </div>
                                                        </div>
                                                        <div className="choices d-flex align-items-center">
                                                            <div className='chiceFields choiceInput'>
                                                                <textarea className="choiceItext" cols={1} defaultValue={"Satisfied"} />
                                                            </div>
                                                            <div className='chiceFields scoreInput'>
                                                                <Tooltip
                                                                    color='primary'
                                                                    content="Custom variables"
                                                                    position='top'
                                                                    className='black-tooltip'
                                                                >
                                                                    <Button view="outlined" className="action-btn copy ms-3" color="primary" text=""><Svg name="copyright" /></Button>
                                                                </Tooltip>
                                                            </div>
                                                        </div>
                                                        <div className="choices d-flex align-items-center">
                                                            <div className='chiceFields choiceInput'>
                                                                <textarea className="choiceItext" cols={1} defaultValue={"Dissatisfied"} />
                                                            </div>
                                                            <div className='chiceFields scoreInput'>
                                                                <Tooltip
                                                                    color='primary'
                                                                    content="Custom variables"
                                                                    position='top'
                                                                    className='black-tooltip'
                                                                >
                                                                    <Button view="outlined" className="action-btn copy ms-3" color="primary" text=""><Svg name="copyright" /></Button>
                                                                </Tooltip>
                                                            </div>
                                                        </div>
                                                        <div className="choices d-flex align-items-center">
                                                            <div className='chiceFields choiceInput'>
                                                                <textarea className="choiceItext" cols={1} defaultValue={"Very dissatisfied"} />
                                                            </div>
                                                            <div className='chiceFields scoreInput'>
                                                                <Tooltip
                                                                    color='primary'
                                                                    content="Custom variables"
                                                                    position='top'
                                                                    className='black-tooltip'
                                                                >
                                                                    <Button view="outlined" className="action-btn copy ms-3" color="primary" text=""><Svg name="copyright" /></Button>
                                                                </Tooltip>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row gx-0 lead-gen-wrapper">
                    <div className="col-lg-6">
                        <div className="tab-inner-wrapper left-tab">
                            <div className="questions-wrapper">
                                <div className="question-list-in">
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="heading2">
                                            <div className="Sortingcheck">
                                                <input type="checkbox" className="form-check-input" id="check2" />
                                            </div>
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#question2" aria-expanded="true" aria-controls="question2">
                                                <strong>Q2</strong> How would you rate the quality of our product?
                                            </button>
                                        </h2>
                                        <div id="question2" className="accordion-collapse collapse" aria-labelledby="heading2" data-bs-parent="#accordionQuestions">
                                            <div className="accordion-body">
                                                <ol>
                                                    <li>Very satisfied</li>
                                                    <li>Satisfied</li>
                                                    <li>Dissatisfied  </li>
                                                    <li>Very dissatisfied </li>
                                                </ol>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="tab-inner-wrapper right-tab">
                            <div className="questions-wrapper">
                                <div className="question-list-in">
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="heading2">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#question2" aria-expanded="true" aria-controls="question2">
                                                <strong>Q2</strong> Bagaimana Anda menilai kualitas produk kami?
                                            </button>
                                        </h2>
                                        <div id="question2" className="accordion-collapse collapse" aria-labelledby="heading2" data-bs-parent="#accordionQuestions">
                                            <div className="accordion-body">
                                                <div className="question-title">
                                                    <EditorMultipleChoice />
                                                </div>
                                                <div className="language-question-option">
                                                    <div className="secondary-font">Choices </div>
                                                    <div className="choices-list">
                                                        <div className="choices d-flex align-items-center">
                                                            <div className='chiceFields choiceInput'>
                                                                <textarea className="choiceItext" cols={1} defaultValue={"Bagaimana Anda m"} />
                                                            </div>
                                                            <div className='chiceFields scoreInput'>
                                                                <Tooltip
                                                                    color='primary'
                                                                    content="Custom variables"
                                                                    position='top'
                                                                    className='black-tooltip'
                                                                >
                                                                    <Button view="outlined" className="action-btn copy ms-3" color="primary" text=""><Svg name="copyright" /></Button>
                                                                </Tooltip>
                                                            </div>
                                                        </div>
                                                        <div className="choices d-flex align-items-center">
                                                            <div className='chiceFields choiceInput'>
                                                                <textarea className="choiceItext" cols={1} defaultValue={"menilai "} />
                                                            </div>
                                                            <div className='chiceFields scoreInput'>
                                                                <Tooltip
                                                                    color='primary'
                                                                    content="Custom variables"
                                                                    position='top'
                                                                    className='black-tooltip'
                                                                >
                                                                    <Button view="outlined" className="action-btn copy ms-3" color="primary" text=""><Svg name="copyright" /></Button>
                                                                </Tooltip>
                                                            </div>
                                                        </div>
                                                        <div className="choices d-flex align-items-center">
                                                            <div className='chiceFields choiceInput'>
                                                                <textarea className="choiceItext" cols={1} defaultValue={"Anda menilai "} />
                                                            </div>
                                                            <div className='chiceFields scoreInput'>
                                                                <Tooltip
                                                                    color='primary'
                                                                    content="Custom variables"
                                                                    position='top'
                                                                    className='black-tooltip'
                                                                >
                                                                    <Button view="outlined" className="action-btn copy ms-3" color="primary" text=""><Svg name="copyright" /></Button>
                                                                </Tooltip>
                                                            </div>
                                                        </div>
                                                        <div className="choices d-flex align-items-center">
                                                            <div className='chiceFields choiceInput'>
                                                                <textarea className="choiceItext" cols={1} defaultValue={"Bagaimana Anda "} />
                                                            </div>
                                                            <div className='chiceFields scoreInput'>
                                                                <Tooltip
                                                                    color='primary'
                                                                    content="Custom variables"
                                                                    position='top'
                                                                    className='black-tooltip'
                                                                >
                                                                    <Button view="outlined" className="action-btn copy ms-3" color="primary" text=""><Svg name="copyright" /></Button>
                                                                </Tooltip>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row gx-0 lead-gen-wrapper">
                    <div className="col-lg-6">
                        <div className="tab-inner-wrapper left-tab">
                            <div className="questions-wrapper">
                                <div className="question-list-in">
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="heading3">
                                            <div className="Sortingcheck">
                                                <input type="checkbox" className="form-check-input" id="check3" />
                                            </div>
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#question3" aria-expanded="true" aria-controls="question3">
                                                <strong>Q3</strong> How satisfied are you with the competency of our product?
                                            </button>
                                        </h2>
                                        <div id="question3" className="accordion-collapse collapse" aria-labelledby="heading3" data-bs-parent="#accordionQuestions">
                                            <div className="accordion-body">
                                                <ol>
                                                    <li>Very satisfied</li>
                                                    <li>Satisfied</li>
                                                    <li>Dissatisfied  </li>
                                                    <li>Very dissatisfied </li>
                                                </ol>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="tab-inner-wrapper right-tab">
                            <div className="questions-wrapper">
                                <div className="question-list-in">
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="heading3">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#question3" aria-expanded="true" aria-controls="question3">
                                                <strong>Q3</strong> Seberapa puaskah Anda dengan kompetensi kam?
                                            </button>
                                        </h2>
                                        <div id="question3" className="accordion-collapse collapse" aria-labelledby="heading3" data-bs-parent="#accordionQuestions">
                                            <div className="accordion-body">
                                                <div className="question-title">
                                                    <EditorMultipleChoice />
                                                </div>
                                                <div className="language-question-option">
                                                    <div className="secondary-font">Choices </div>
                                                    <div className="choices-list">
                                                        <div className="choices d-flex align-items-center">
                                                            <div className='chiceFields choiceInput'>
                                                                <textarea className="choiceItext" cols={1} defaultValue={"Bagaimana Anda m"} />
                                                            </div>
                                                            <div className='chiceFields scoreInput'>
                                                                <Tooltip
                                                                    color='primary'
                                                                    content="Custom variables"
                                                                    position='top'
                                                                    className='black-tooltip'
                                                                >
                                                                    <Button view="outlined" className="action-btn copy ms-3" color="primary" text=""><Svg name="copyright" /></Button>
                                                                </Tooltip>
                                                            </div>
                                                        </div>
                                                        <div className="choices d-flex align-items-center">
                                                            <div className='chiceFields choiceInput'>
                                                                <textarea className="choiceItext" cols={1} defaultValue={"menilai "} />
                                                            </div>
                                                            <div className='chiceFields scoreInput'>
                                                                <Tooltip
                                                                    color='primary'
                                                                    content="Custom variables"
                                                                    position='top'
                                                                    className='black-tooltip'
                                                                >
                                                                    <Button view="outlined" className="action-btn copy ms-3" color="primary" text=""><Svg name="copyright" /></Button>
                                                                </Tooltip>
                                                            </div>
                                                        </div>
                                                        <div className="choices d-flex align-items-center">
                                                            <div className='chiceFields choiceInput'>
                                                                <textarea className="choiceItext" cols={1} defaultValue={"Anda menilai "} />
                                                            </div>
                                                            <div className='chiceFields scoreInput'>
                                                                <Tooltip
                                                                    color='primary'
                                                                    content="Custom variables"
                                                                    position='top'
                                                                    className='black-tooltip'
                                                                >
                                                                    <Button view="outlined" className="action-btn copy ms-3" color="primary" text=""><Svg name="copyright" /></Button>
                                                                </Tooltip>
                                                            </div>
                                                        </div>
                                                        <div className="choices d-flex align-items-center">
                                                            <div className='chiceFields choiceInput'>
                                                                <textarea className="choiceItext" cols={1} defaultValue={"Bagaimana Anda "} />
                                                            </div>
                                                            <div className='chiceFields scoreInput'>
                                                                <Tooltip
                                                                    color='primary'
                                                                    content="Custom variables"
                                                                    position='top'
                                                                    className='black-tooltip'
                                                                >
                                                                    <Button view="outlined" className="action-btn copy ms-3" color="primary" text=""><Svg name="copyright" /></Button>
                                                                </Tooltip>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row gx-0 lead-gen-wrapper">
                    <div className="col-lg-6">
                        <div className="tab-inner-wrapper left-tab">
                            <div className="questions-wrapper">
                                <div className="question-list-in">
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="heading4">
                                            <div className="Sortingcheck">
                                                <input type="checkbox" className="form-check-input" id="check4" />
                                            </div>
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#question4" aria-expanded="true" aria-controls="question4">
                                                <strong>Q4</strong> How satisfied are you with the competency of our product?
                                            </button>
                                        </h2>
                                        <div id="question4" className="accordion-collapse collapse" aria-labelledby="heading4" data-bs-parent="#accordionQuestions">
                                            <div className="accordion-body">
                                                <ol>
                                                    <li>Very satisfied</li>
                                                    <li>Satisfied</li>
                                                    <li>Dissatisfied  </li>
                                                    <li>Very dissatisfied </li>
                                                </ol>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="tab-inner-wrapper right-tab">
                            <div className="questions-wrapper">
                                <div className="question-list-in">
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="heading4">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#question4" aria-expanded="true" aria-controls="question4">
                                                <strong>Q4</strong> Seberapa puaskah Anda dengan kompetensi kam?
                                            </button>
                                        </h2>
                                        <div id="question4" className="accordion-collapse collapse" aria-labelledby="heading4" data-bs-parent="#accordionQuestions">
                                            <div className="accordion-body">
                                                <div className="question-title">
                                                    <EditorMultipleChoice />
                                                </div>
                                                <div className="language-question-option">
                                                    <div className="secondary-font">Choices </div>
                                                    <div className="choices-list">
                                                        <div className="choices d-flex align-items-center">
                                                            <div className='chiceFields choiceInput'>
                                                                <textarea className="choiceItext" cols={1} defaultValue={"Bagaimana Anda m"} />
                                                            </div>
                                                            <div className='chiceFields scoreInput'>
                                                                <Tooltip
                                                                    color='primary'
                                                                    content="Custom variables"
                                                                    position='top'
                                                                    className='black-tooltip'
                                                                >
                                                                    <Button view="outlined" className="action-btn copy ms-3" color="primary" text=""><Svg name="copyright" /></Button>
                                                                </Tooltip>
                                                            </div>
                                                        </div>
                                                        <div className="choices d-flex align-items-center">
                                                            <div className='chiceFields choiceInput'>
                                                                <textarea className="choiceItext" cols={1} defaultValue={"menilai "} />
                                                            </div>
                                                            <div className='chiceFields scoreInput'>
                                                                <Tooltip
                                                                    color='primary'
                                                                    content="Custom variables"
                                                                    position='top'
                                                                    className='black-tooltip'
                                                                >
                                                                    <Button view="outlined" className="action-btn copy ms-3" color="primary" text=""><Svg name="copyright" /></Button>
                                                                </Tooltip>
                                                            </div>
                                                        </div>
                                                        <div className="choices d-flex align-items-center">
                                                            <div className='chiceFields choiceInput'>
                                                                <textarea className="choiceItext" cols={1} defaultValue={"Anda menilai "} />
                                                            </div>
                                                            <div className='chiceFields scoreInput'>
                                                                <Tooltip
                                                                    color='primary'
                                                                    content="Custom variables"
                                                                    position='top'
                                                                    className='black-tooltip'
                                                                >
                                                                    <Button view="outlined" className="action-btn copy ms-3" color="primary" text=""><Svg name="copyright" /></Button>
                                                                </Tooltip>
                                                            </div>
                                                        </div>
                                                        <div className="choices d-flex align-items-center">
                                                            <div className='chiceFields choiceInput'>
                                                                <textarea className="choiceItext" cols={1} defaultValue={"Bagaimana Anda "} />
                                                            </div>
                                                            <div className='chiceFields scoreInput'>
                                                                <Tooltip
                                                                    color='primary'
                                                                    content="Custom variables"
                                                                    position='top'
                                                                    className='black-tooltip'
                                                                >
                                                                    <Button view="outlined" className="action-btn copy ms-3" color="primary" text=""><Svg name="copyright" /></Button>
                                                                </Tooltip>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
